<template>
  <div class="match-invite-page page">
    <Breadcrumb />
    <!-- 主体 -->

    <main class="main">
      <section>
        <div class="title-wrap">
          <span class="c-title">结果列表</span>
          <span class="english-name">RESULT LIST</span>
        </div>
      </section>
      <section class="content">
        <div class="c-left">
          <!-- 内容 -->
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in newsList"
              :key="index"
              @click="articleDetailClick(item)"
            >
              <div class="i-center">
                <h2 class="title">{{ item.articleName }}</h2>
              </div>
              <div class="i-right">
                <div class="news-time">[{{ item.releaseTime }}]</div>
              </div>
            </div>
          </div>
          <!-- 页码 -->
          <Pagination
            :pageSize="pageSize"
            :pageCount="pageCount"
            @changePageClick="changePageClick"
            v-if="newsList.length > 0"
          ></Pagination>
          <el-empty
            description="暂无行业资讯"
            v-if="newsList.length == 0"
          ></el-empty>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/breadcrumb'
import Pagination from '@/components/common/Pagination.vue'
import { searchArticle } from '@/api/home/home.js'
export default {
  name: 'Policy',
  components: { Breadcrumb, Pagination },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: null,
      newsList: [],
      keyWord: ''
    }
  },
  methods: {
    //统一获取数据
    fetchData() {
      this.tabList = {
        categoryCode: '',
        categoryName: '结果列表',
        list: []
      }
      this.getArticlePage()
    },
    //获取文章列表
    getArticlePage(page = 1) {
      console.log('getArticlePage-------')
      searchArticle({
        page: page,
        limit: this.pageSize,
        articleName: this.keyWord
      }).then((res) => {
        if (!res.data) return

        this.newsList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    //跳转文章详情
    articleDetailClick(item) {
      let url = '/searchPage/searchDetail?id=' + item.articleId

      this.$router.push({
        path: url
      })
    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page)
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表,6/新闻详情
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl)
        url = '/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/singleImage' + url
      }
      if (item.linkType == 3) {
        this.getArticlePage()
        url = '/imageText' + url
      }
      if (item.linkType == 4) {
        url = '/textList' + url
      }
      if (item.linkType == 6) {
        url = '/articleDetail' + url
      }

      this.$router.push({
        path: url
      })
    }
  },
  created() {
    this.keyWord = this.$route.query?.keyWord
    this.fetchData()
  },
  mounted() {},
  watch: {
    //监听路由，处理嵌套路由问题
    $route: {
      handler() {
        if (this.$route.path.includes('searchResult')) {
          this.displayNewsList = true
        } else {
          this.displayNewsList = false
        }
      },
      // 一进页面就执行
      immediate: true,
      // 深度观察监听
      deep: true
    },
    '$route.query.keyWord'(newValue) {
      console.log('newValue-------', newValue)

      this.keyWord = newValue
      this.getArticlePage()
    }
  }
}
</script>

<style lang="scss" scoped>
.match-invite-page {
  display: flex;
  flex-direction: column;
  .main {
    width: 1340px;
    margin: 0 auto;
    background-color: #ffffff;

    .title-wrap {
      margin-top: 30px;
      .c-title {
        font-size: 30px;
        padding-left: 17px;
        border-left: 3px solid rgb(12, 108, 228);
        font-weight: 700;
      }
      .english-name {
        color: rgb(153, 153, 153);
        margin-left: 10px;
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 10px;
      margin-bottom: 50px;

      .c-left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        padding-bottom: 70px;

        .list {
          display: flex;
          flex-direction: column;

          .item:hover .i-center .title,
          .item:hover .i-center .desc,
          .item:hover .i-right .i-right-top,
          .item:hover .i-right .news-time,
          .item:hover .i-right .i-right-bottom {
            color: #1b56a9 !important;
            text-decoration: underline;
          }

          .item {
            display: flex;
            align-items: center;
            justify-content: stretch;
            padding: 20px 0;
            // margin-top: 12px;
            cursor: pointer;
            border-bottom: 1px dashed #e4e4e4;

            .i-center {
              flex: 1;
              .title {
                color: #000000;
                padding: 0;
                font-weight: normal;
                font-size: 18px;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
              }
            }
            .i-right {
              position: relative;
              text-align: center;
              .news-time {
                margin-left: 10px;
                color: #999;
                font-size: 16px;
              }
            }
          }
          .item:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .main {
      width: 345px;
      .title-wrap {
        margin-top: 20px;
        .english-name {
          font-size: 14px;
          margin-left: 6px;
        }
        .c-title {
          font-size: 20px;
          border-left: 2px solid rgb(12, 108, 228);
          padding-left: 10px;
        }
      }
      .content {
        margin-top: 8px;
        margin-bottom: 30px;
        .c-left {
          padding-bottom: 30px;
        }
        .list {
          .item {
            margin-top: 10px;
            padding: 8px 0;
            .i-center {
              .title {
                font-size: 14px;
              }
            }
            .i-right {
              .news-time {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
